import React from 'react';
import PropTypes from 'prop-types';

import utils from './utils';
import Avatar from '../Components/Avatar';

const SimpleComment = ({ comment, children }) =>
    (<div className='comment-simple'>
        <div className='comment-one-liner'>
            <Avatar
                name={comment.author}
                email={comment.owner.email}
                login={comment.owner.login}
                classes={'comment-avatar'}
            />
            <div
                className='content comment-text'
                dangerouslySetInnerHTML={
                    utils.createMarkup(
                        comment.content.length > 180
                            ? `${comment.content.replace(/^(.{180}[^\s]*).*/, '$1')}...`
                            : comment.content
                    )
                }
            />
        </div>

        { children }

    </div>);

export default SimpleComment;

SimpleComment.propTypes = {
    comment: PropTypes.object
};
